import { useIntl } from "react-intl";
import { HairProductKey } from "~/api/models/HairProductKey";
import { useFetchProducts } from "~/api/salesForce/useFetchProducts";
import ProductCard from "~/components/organisms/Pricing/ProductCard/ProductCard";
import useDefaultProduct from "~/hooks/useDefaultProduct";
import useHairProducts from "~/hooks/useHairProducts";
import { Product } from "~/stores/checkout/product";

const MesotherapyCard = () => {
  const intl = useIntl();
  const { data: allProducts, isLoading } = useFetchProducts();
  const { mesotherapyProduct, setMesotherapyProduct } = useHairProducts();

  const defaultProduct = useDefaultProduct(allProducts.hair.head.mesotherapy);

  return (
    <ProductCard
      hairProductFamilyKey={HairProductKey.mesotherapy}
      defaultProduct={defaultProduct}
      cardTitle={intl.formatMessage({
        id: "pricing.mesotherapyHair",
      })}
      product={mesotherapyProduct}
      setProduct={
        setMesotherapyProduct as (
          product?: Product | Product[] | undefined
        ) => void
      }
      options={allProducts.hair.head.mesotherapy}
      blankOptionTitle={intl.formatMessage({
        id: "treatment.pricing.mesotherapyHair.none",
      })}
      modalTitle={intl.formatMessage({
        id: "pricing.mesotherapyHair",
      })}
      isLoading={isLoading}
    />
  );
};

export default MesotherapyCard;
